/**
 * 시스템 > 장비관리 > 장비 관리 구성/현황 Store
 *
 * @since 2018-03-12
 * @author devp010
 */

import { pcDownloadFile } from '~/utils/files'
import { SystemApiPrefix as apiPrefix } from '~/utils/restApi'

export const state = () => ({
  BASE_URL: `${apiPrefix}/devices`,
  deviceStatusDataList: []
})

export const mutations = {
  initStore (state) {
    state.deviceStatusDataList = []
  },
  // 본문 리스트
  setDeviceList (state, result) {
    state.deviceStatusDataList = Object.freeze(_.cloneDeep(result))
  }
}

export const actions = {
  async getDeviceList ({commit, state}, payload) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${state.BASE_URL}?device_id=${payload.device_id}`)
      if (res.code === 'ok') {
        commit('setDeviceList', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async getExcel ({commit, state}) { // PC로 파일 다운로드
    const res = {
      code: 'ok',
      result: {}
    }

    try {
      const {data, fileName} = await this.$axios.$file(`${state.BASE_URL}/download`, {
        responseType: 'blob',
        method: 'get',
        successAlert: false
      })
      const nameData = fileName.replace('UTF-8\'\'', '')
      pcDownloadFile(data, nameData)

      res.code = 'ok'
    } catch (e) {
      res.code = 'nok'
      res.result = {
        msg: e.message
      }
    }
    return res
  }
}

export const getters = {}

export const strict = false
